import { Avatar, AvatarFallback } from '@ooh/ui/components/avatar';
import { Button } from '@ooh/ui/components/button';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from '@ooh/ui/components/dropdown-menu';
import { LogOut } from 'lucide-react';

export function UserMenu({
  userName,
  userEmail,
  logoutLabel,
  onLogout,
}: {
  userName: string;
  userEmail: string;
  logoutLabel: string;
  onLogout: () => void;
}) {
  const initials =
    userName
      .split(' ')
      .map((n) => n[0])
      .join('')
      .slice(0, 2)
      .toUpperCase() || '??';

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="flex items-center gap-2.5 px-1.5"
          data-testid="user-avatar"
        >
          <Avatar className="h-8 w-8">
            <AvatarFallback className="text-[11px] font-medium bg-primary text-primary-foreground">
              {initials}
            </AvatarFallback>
          </Avatar>
          <span className="text-[14px] font-medium hidden sm:block">{userName}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        <div className="px-2 py-1.5 text-[12px] text-muted-foreground">{userEmail}</div>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onSelect={onLogout}
          className="text-destructive focus:text-destructive"
          data-testid="logout-button"
        >
          <LogOut className="h-4 w-4 mr-2" />
          {logoutLabel}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
